function InvoiceTypes() {
    return (
        <div className="row">
            <div className="col-xl-12">
                <div className="card stretch stretch-full">
                    <div className="card-header">
                        <h5 className="card-title">انواع صورتحساب</h5>
                    </div>
                    <div className="card-body custom-card-action p-0">
                        <div className="table-responsive">
                            <table className="table table-hover mb-0">
                                <thead>
                                    <tr className="border-b">
                                        <th>کد</th>
                                        <th>عنوان نوع صورتحساب</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td>صورتحساب کاغذی</td>
                                    </tr>
                                    <tr>
                                        <td>2</td>
                                        <td>صورتحساب الکترونیکی نوع اول</td>
                                    </tr>

                                    <tr>
                                        <td>3</td>
                                        <td>صورتحساب الکترونیکی نوع دوم</td>
                                    </tr>

                                    <tr>
                                        <td>4</td>
                                        <td>صورتحساب الکترونیکی نوع سوم</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default InvoiceTypes;